export default "__VITE_ASSET__BdZ7Dvla__"